import useModal from 'lib/hooks/useModal';

import Button from 'components/shared/Button/Button';
import Icon from 'components/shared/Icon/Icon';

import AddPayerModal from './AddPayerModal/AddPayerModal';

const EmptyPayers = ({ practiceId }) => {
  const {
    isOpen: isAddPayerOpen,
    openModal: openAddPayerModal,
    closeModal: closeAddPayerModal
  } = useModal();

  return (
    <>
      <div className="flex w-full flex-col items-center pb-20">
        <Icon icon="illustration-empty-table" />
        <h1 className="text-base font-500 text-primary-900">No payers found!</h1>
        <Button
          className="mt-4"
          textClassName="whitespace-nowrap"
          text="Add payer"
          icon="add-square-mono"
          size="xs"
          variant="link"
          onClick={openAddPayerModal}
        />
      </div>

      {isAddPayerOpen && (
        <AddPayerModal
          isOpen={isAddPayerOpen}
          practiceId={practiceId}
          handleClose={closeAddPayerModal}
        />
      )}
    </>
  );
};
export default EmptyPayers;
